export const MAX_DATE = '12/31/2099';
export const MIN_DATE = '01/01/1900';
export const MAX_TEXT_LENGTH = 1024;
export const rusPhoneCode = '+7';
export const rusPassportCode = '21';
export const countryInfoRussia = {
    fullName: 'Российская Федерация',
    code: '643',
    shortName: 'Россия',
};
export const rusResidentStatuses = '1';
export const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const maskFormatChars = {
    '9': '[0-9]',
    a: '[A-Za-z]',
    '*': '[A-Za-z0-9]',
    L: '[А-Яа-яA-Za-z0-9]',
};
/**
 * @deprecated замени на строку 'employeeList'
 */
export const staffServiceEmployeeListCategory = 'employeeList';
/**
 * @deprecated замени на строку 'employee'
 */
export const staffServiceEmployeeCategory = 'employee';
